import BackpacksIcon from './component.jsx'

export default BackpacksIcon
